module.exports = __webpack_public_path__ + "media/images/icon_arrow-e5f28ec388a98a8f7a092177315e30e2.png";